import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MeetingService } from './meeting.service';
import { environment } from 'src/environments/environment';
import { MeetingHandlerService, NotificationMessages } from './meeting-handler.service';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import fixWebmDuration from "fix-webm-duration";
import { CancellationToken, UtilService } from './util.service';
import { ProctorLevels } from '../proctor/app-proctor.component';
import { AIFlags, AIPreventExamStartResponse, AiProctorService } from './aiproctor.service';
import { SecondViewIframeComponent } from '../second-view-iframe/second-view-iframe.component';
import { ExamiframeComponent } from '../examiframe/examiframe.component';
import { Participant } from '../models/Participant';
import { ChatmodalComponent } from '../chatmodal/chatmodal.component';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { InitiateSecondViewModalComponent } from '../initiate-second-view-modal/initiate-second-view-modal.component';

declare const MediaRecorder: any;
declare const SafeExamBrowser;
//declare var testUploadFailure: any;

@Injectable({
  providedIn: 'root'
})
export class ProctorService {
  streamchunks = new Map<number, any>();
  streamChunksArray = [];
  recordingStartTime: number;
  //firstRecordingUploadTime: number;
  //let recordingsno = 0;
  

  uploadstreamchunksinterval;

  chunksuploaded = 0;
  chunkscreated = 0;

  mediaRecorder: MediaRecorder;

  //publishvideointerval: any;
  examid!: number;
  examdesc!: string;
  company!: string;
  attempt!: number;
  //overrideai!: boolean;
  passportversion!: number;
  passporttype!: string;
  aiCheckPhotoBeforeStart: boolean;
  name!: string;
  loggedInUsername!: string;
  passporturl!: string

  private _recording = false;
  private recorderStarted = false;

  videostream: MediaStream;

  recordinguploadstartedinterval;
  examUrl: string;

  //videoProducer;
  //audioProducer;

  proctorSocketId: string;

  req_headers = new HttpHeaders({ "content-type": "application/json", "accept": "application/json" });
  restartRecordingTimeout: any;

  recorderBps = (480 * 240 * 24 * 1 * 0.07);
  lastVideoChunkUploadedTime: number;
  resetLastStreamChunkUploadFailedInterval: any;
  // lastVideoUploadedRecordingTime: number;
  // lastVideoUploadedPart: number;
  scheduleid: number;
  allowExternalWebcam: boolean = false;
  secondViewRequired: boolean = false;
  isSecondViewProctor: boolean = false;
  isInteractiveSecondView: boolean = false;//it is interactive second view if the user has used an external device to go to the second view
  startSecondViewProctor: boolean = false;

  proctorInfo: any;

  connecting: boolean = false;
  stopConnecting: any = false;

  started = false;

  prevenstart: AIPreventExamStartResponse;

  secondViewIframeComponent: SecondViewIframeComponent;
  examIframeComponent: ExamiframeComponent;

  private meetingAuths = {};

  maximumMeetingUsers = 41;//added 1 for the proctor
  checkForHostsInterval: any;

  audios = {};//this is an object of audios[socketid][producerid] = new Audio();

  private chatModalRef: NgbModalRef | undefined;
  //private initiateSecondViewModalRef: NgbModalRef | undefined;

  primaryViewDeviceLabel: string;
  allowExternalSecondViewWebcam: any;
  secondViewDeviceLabel: string;
  checkForSecondViewParticipantInterval: any;
  //this variable stores the video device label
  //for dual view, we wil use this as the primary device label
  videoDeviceLabel: string;
  secondViewPreference: string;
  secondViewRTCPeerConnection: RTCPeerConnection;
  // secondViewPreferencePromiseResolveFunction: (value: boolean | PromiseLike<boolean>) => void;
  // secondViewPreferencePromiseRejectFunction: (reason?: any) => void;

  constructor(private meetingService: MeetingService, private meetingHandlerService: MeetingHandlerService, private http: HttpClient, private util: UtilService, private aiProctorService: AiProctorService, private toastr: ToastrService, private modalService: NgbModal) {
    this.meetingHandlerService.allowAutoReconnect = false;
    this.company = this.getCompany();
    this.company = this.company.toLowerCase();
    window.addEventListener('message', (evt: any) => {
      this.secondViewProctorMessageListener(evt);
    });
  }

  destroy() {
    //not sure i need this
    this.proctorSocketId = null;
  }


  async publishVideo() {
    this.meetingHandlerService.audioAvailable = true;
    this.meetingHandlerService.videoAvailable = true;

    const producingvideo = this.producing('video');
    const producingaudio = this.producing('audio');
    if (this.meetingHandlerService.ready && producingvideo && producingaudio) {
      //console.log('start - published video');
      return;
    }

    //console.log('stopping publishing in publish video');
    await this.stopPublishing(false);

    let stream = await this.getVideoStream(this.allowExternalWebcam);

    //await this.startRecording(stream);

    // this.meetingHandlerService.localAudioTrack = stream.getAudioTracks()[0];
    // this.meetingHandlerService.localVideoTrack = stream.getVideoTracks()[0];

    //await Promise.allSettled([this.meetingHandlerService.publishVideo(false), this.meetingHandlerService.publishAudio(false)]);
    //const recordingUploadStartedPromise = this.recordingUploadStarted();

    await Promise.all([this.meetingHandlerService.publishToMediasoupRoom(stream.getVideoTracks()[0], false, undefined, false),
     this.meetingHandlerService.publishToMediasoupRoom(stream.getAudioTracks()[0], false, undefined, false)]);

    //this.meetingHandlerService.publishVideo()

    // this.videoProducer = producers[0];
    // this.audioProducer = producers[1];

    //console.log('waiting for record upload to start');
    //await recordingUploadStartedPromise;//we will wait until video upload has started before we certify that upload has started. the actual uploading will be triggered from the connectedSubject, which will happen
    //console.log('record uploading started');
  }

  async stopPublishing(stopvideostream) {//trackended is a variable i've decided to set when any of the tracks in the video stream ends...if a track has ended, then the stream isn't good anyway and we should stop it so we can create a new one 
    if (this.videostream) {
      let tracks = [...this.videostream.getVideoTracks(), ...this.videostream.getAudioTracks()];
      tracks.forEach(t => {
        try {
          const producer = this.findProducerByTrack(t);
          if (producer) {// && this.meetingHandlerService.ready) {
            this.meetingHandlerService.closeProducer(producer, false);
          }
          if (stopvideostream || (this.videostream && (this.videostream as any).trackended)) {
            t.stop();
          }
        }
        catch (error) {
          console.log(error);
        }
      });
    }

    if (stopvideostream) {
      this.videostream = null;
      //debugger;
      await this.stopRecording();
    }
  }

  findProducerByTrack(track: MediaStreamTrack){
    const producers = [this.meetingHandlerService.videoProducer, this.meetingHandlerService.audioProducer, this.meetingHandlerService.screenShareVideoProducer, this.meetingHandlerService.screenShareAudioProducer];
    for(let i = 0; i < producers.length; i++){
      if(producers[i] && producers[i].track.id == track.id){
        return producers[i];
      }
    }
    return null;
  }

  producing(kind: string) {
    switch (kind) {
      case 'video':
        return this.meetingHandlerService.ready && this.meetingHandlerService.videoProducer && !this.meetingHandlerService.videoProducer.closed;
      case 'audio':
        return this.meetingHandlerService.ready && this.meetingHandlerService.audioProducer && !this.meetingHandlerService.audioProducer.closed;
      default:
        throw new Error('Unexpected producer type');
    }
  }

  recording() {
    return this.mediaRecorder && 
           this.recorderStarted && 
           this.lastVideoChunkUploadedTime && 
           (Date.now() - this.lastVideoChunkUploadedTime) < (120 * 1000)//itis 60 seconds on the server and 120 secnds here to give the userr a chance to reconnect before being kicked out of the exam
  }

  getRecordingMimeType() {
    return MediaRecorder.isTypeSupported('video/webm') ? 'video/webm' : 'video/mp4';
  }

  async startRecording(secondView: boolean, allowExternalWebcam: boolean, restarting: boolean) {
    const stream = await this.getVideoStream(allowExternalWebcam) as MediaStream;
    let recordingtime = 0;
    this.lastVideoChunkUploadedTime = 0;

    if (!await this.checkCanUploadInChunks()) {
      throw new Error('Segmented recording not supported');
    }

    const retrievedUploadUrls = new Map<number, string>();

    const retrieveUploadUrl = async (part: number) => {
      if (!retrievedUploadUrls.has(part)) {

        //this url should generate a number of presigned urls
        const numberOfPresignedUrls = 100;
        const generatePresignedUrlEndpoint = `${environment.proctorServiceRootUrl}recordings3/getpresignedurls?company=${encodeURIComponent(this.company)}&examid=${encodeURIComponent(this.examid)}&username=${encodeURIComponent(this.loggedInUsername)}&time=${encodeURIComponent(recordingtime)}&partStart=${part}&partEnd=${(part + numberOfPresignedUrls - 1)}&mimeType=${encodeURIComponent(this.getRecordingMimeType())}&secondView=${secondView}`;

        const uploadUrls = await this.util.tryGet(generatePresignedUrlEndpoint);

        for (const _part in uploadUrls) {
          retrievedUploadUrls.set(parseInt(_part), uploadUrls[_part]);
        }
      }

      if (!retrievedUploadUrls.has(part)) {
        throw new Error(`Upload url for part ${part} not found`);
      }

      const url = retrievedUploadUrls.get(part);
      //retreivedUploadUrls.delete(part);
      return url;
    };

    // const deleteUploadUrl = (part: number) => {
    //   retrievedUploadUrls.delete(part);
    // }

    //const uploadurl = `${environment.proctorServiceRootUrl}recording/uploadpart`
    let lastStreamChunkUploadFailed = false;
    const uploadStreamChunk = async (part: number, chunk: any) => {
      var blob = new Blob([chunk], { 'type': this.getRecordingMimeType() });
      // var fd = new FormData();
      // fd.append('data', blob);

      //const apiUrl = `${uploadurl}?company=${this.company}&examid=${this.examid}&username=${this.loggedInUsername}&time=${this.recordingtime}&part=${part + 1_000_000_000}`;


      try {
        const url = await retrieveUploadUrl(part);

        //await this.http.post(apiUrl, fd).toPromise();
        
        //this if statement was just to test how the system would behave when you are unable to upload 
        // if(testUploadFailure && this.chunksuploaded > 3){
        //   throw new Error('Upload failed');
        // }

        const headers = new HttpHeaders().set('Content-Type', this.getRecordingMimeType());
        
        await this.http.put(url, blob, { headers: headers }).toPromise();

        //loglastuploadtimes
        await this.logLastVideoUploadedTime(recordingtime, part, this.isSecondViewProctor);

        this.chunksuploaded++;
        this.lastVideoChunkUploadedTime = Date.now();
        lastStreamChunkUploadFailed = false;

        // this.lastVideoUploadedRecordingTime = recordingtime;
        // this.lastVideoUploadedPart = part;
        //}
        //deleteUploadUrl(part);
        return true;
      }
      catch (error) {
        if(this.isSecondViewProctor){
          this.toastr.warning('Unstable network conditions');
        }
        lastStreamChunkUploadFailed = true;
        console.error(error);
        return false;
      }

    };

    console.log('starting recording');
    await this.stopRecording(restarting);

    //we want to wait until we are sure we have stopped recording (which would make sure all pending uploads are done) before we reset the values below
    this.chunksuploaded = 0;
    this.chunkscreated = 0;
    this.streamchunks = new Map<number, any>();

    let firstUploadDonePromiseResolveFunction;
    let firstUploadDonePromise = new Promise((resolve, reject) => {
      firstUploadDonePromiseResolveFunction = resolve;
    })

    console.log('starting upload interval...');
    this.uploadstreamchunksinterval = setInterval(async () => {

      //also ensure that the first chunk goes quickly
      if (this.streamchunks.size > 0 && !lastStreamChunkUploadFailed) {//if the last upload failed, we don't want to keep adding more upload loops
        const part: number = this.streamchunks.keys().next().value;
        const chunk = this.streamchunks.get(part);
        this.streamchunks.delete(part);
        while (!await uploadStreamChunk(part, chunk)) {
          await this.util.sleep(1000);//if upload failed, wait for 1 second before trying again
        }

        if(firstUploadDonePromise){
          firstUploadDonePromise = null;
          firstUploadDonePromiseResolveFunction();
        }
      }
    }, 10);

    if(this.resetLastStreamChunkUploadFailedInterval){
      clearInterval(this.resetLastStreamChunkUploadFailedInterval);
    }

    this.resetLastStreamChunkUploadFailedInterval = setInterval(() => {
      lastStreamChunkUploadFailed = false;
    }, 30 * 1000)//ever 30 seconds, reset the lastStreamChunkUploadFailed value just in case so we try again. We shouldn't need this, this is insurance

    recordingtime = await this.getServerTimeTicks();// new Date().getTime();
    this.mediaRecorder = new MediaRecorder(stream, { mimeType: this.getRecordingMimeType(), bitsPerSecond: this.recorderBps });

    let uploadPart = 1_000_000_000;//we want the partial file names to start high so that the file name lengths will be the same. it also means it can be ordered alphabetically

    this.mediaRecorder.ondataavailable = (e) => {
      if (e.data && e.data.size > 0) {
        //const time = new Date().getTime();
        //const time = ++uploadPartId;
        // if (this.streamChunksArray.length == 0) {
        //   this.firstRecordingUploadTime = time;
        // }

        uploadPart++;

        this.streamchunks.set(uploadPart, e.data);
        this.streamChunksArray.push(e.data);

        this.chunkscreated++;
      }
      //if (this.streamchunks.length > 1000) {
      //    const localpartno = new Date().getTime();
      //    uploadthis.streamchunks(localpartno).catch((error) => { console.log('error uploading'); });
      //}
    };
    this.mediaRecorder.onstop = (e) => {
      //const localpartno = new Date().getTime();
      //uploadthis.streamchunks(localpartno).catch((error) => { console.log('error uploading'); });

      //we cannot wait for more than 5 seconds for all the pending stream chunks to be uploaded
      const checkifalluploadsdoneinterval = setInterval(async () => {
        if (this.streamchunks.size === 0) {

          //console.log('upload interval cleared...');
          clearInterval(this.uploadstreamchunksinterval);
          clearInterval(checkifalluploadsdoneinterval);

          //fix header
          if (this.getRecordingMimeType() == 'video/webm') {
            const duration = Date.now() - this.recordingStartTime;

            console.log(`Recording duration is ${duration}`);

            const buggyBlob = new Blob(this.streamChunksArray, { type: this.getRecordingMimeType() });

            const fixedBlob = await fixWebmDuration(buggyBlob, duration, { logger: console.log });

            console.log(`fixed webm duration. new duration: ${duration}`);

            //check if buggyBlob and fixedBlob are the same size (they are not. fixedBlob is bigger)
            //get numberOfBytesInFirstChunck
            //get the difference in size (sizeDifference) between fixedBlob and buggyBlob
            //numberOfBytesInNewFirstChunk = numberOfBytesInFirstChunk + sizeDifference (as we will assume it is the header that has been made larger)
            //extract numberOfBytesInNewFirstChunk no of bytes from the fixed blob into a fixedHeaderBlob
            //upload the fixedHeaderBlob to the replace the previously uploaded first file in the recording

            const numberOfBytesInFirstChunk = this.streamChunksArray[0].size;
            const sizeDifference = fixedBlob.size - buggyBlob.size;
            const numberOfBytesInNewFirstChunk = numberOfBytesInFirstChunk + sizeDifference;

            const fixedBlobFirstChunk = fixedBlob.slice(0, numberOfBytesInNewFirstChunk, 'application/octet-stream');

            

            //while (!await uploadStreamChunk(1, fixedBlobFirstChunk));
            while (!await uploadStreamChunk(1_000_000_001, fixedBlobFirstChunk));//we started at 1 billion, so the first chunk will be 1billion + 1
          }

          const _markRecordingAsFinished = async () => {
            while(true){
              try{
                const markAsFinishedEndpoint = `${environment.proctorServiceRootUrl}recordings3/markasfinished?company=${encodeURIComponent(this.company)}&examid=${encodeURIComponent(this.examid)}&username=${encodeURIComponent(this.loggedInUsername)}&time=${encodeURIComponent(recordingtime)}&secondView=${secondView}`;
                await this.util.tryPost(markAsFinishedEndpoint, {}, { headers: this.req_headers });

                this.processRecording(recordingtime);//don't await this. we want to request and forget. we aren't using the resulting file here. we just want it processed early

                return;
              }
              catch(error){
                console.error(error);
              }
            }
          };

          _markRecordingAsFinished();
          
          

          //const fixedBlobFirstChunkUrl = URL.createObjectURL(fixedBlobFirstChunk);

          // const c = document.createElement('a');
          // c.href = fixedBlobFirstChunkUrl;
          // c.download = "fixedHeader";
          // document.body.appendChild(c);
          // c.click();

          this.streamChunksArray = [];

          this._recording = false;

          this.recordingStartTime = 0;
          //this.firstRecordingUploadTime = 0;
        }
      }, 10);
    };

    this.streamchunks = new Map();
    this.streamChunksArray = [];
    this.mediaRecorder.start(10 * 1000);

    // while(true){
    //   try{
    //     this.recordingStartTime = await this.getServerTimeTicks();
    //     break;
    //   }
    //   catch(error){
    //     this.toastr.warning('Error getting server time. If this persists, please check your network connection');
    //     console.error(error);
    //   }
    // }
    this.recordingStartTime = Date.now();
    this._recording = true;
    this.recorderStarted = true;

    //limit recordings to 10 minutes each
    if (this.restartRecordingTimeout) {
      clearTimeout(this.restartRecordingTimeout);
      this.restartRecordingTimeout = null;
    }
    this.restartRecordingTimeout = setTimeout(async () => {
      await this.restartRecording(this.isSecondViewProctor);
    }, 10 * 60 * 1000);//each recording should be 10 minutes long because we don't want to hold too much recording data in memory.

    await firstUploadDonePromise;
  }

  async checkCanUploadInChunks() {
    const stream = await this.getVideoStream(true);
    const mediaRecorder = new MediaRecorder(stream, { mimeType: this.getRecordingMimeType(), bitsPerSecond: this.recorderBps });

    let accepted = false;

    let acceptfn: (value: boolean | PromiseLike<boolean>) => void;

    mediaRecorder.ondataavailable = () => {
      if (acceptfn && !accepted) {
        accepted = true;
        mediaRecorder.stop();
        acceptfn(true);
      }
    };

    mediaRecorder.start(10);

    //if 10 seconds have passed, and ondataavailable hasn't fired, then cancel
    this.sleep(10000).then(() => {
      if (acceptfn && !accepted) {
        accepted = true;
        mediaRecorder.stop();
        acceptfn(false);
      }
    });

    return new Promise<boolean>((accept, reject) => {
      acceptfn = accept;
    })
  }

  // recordingUploadStarted() {

  //   return new Promise<void>((accept, reject) => {
  //     let accepted = false;
  //     this.sleep(10000).then(() => {//if in 10 seconds, upload hasn't happened, then reject
  //       if(!accepted){
  //         reject();
  //       }
  //     });
  //     this.recordinguploadstartedinterval = setInterval(() => {
  //       console.log('checking if upload has happened..');
  //       if (this.chunksuploaded > 0) {
  //         clearInterval(this.recordinguploadstartedinterval);
  //         console.log(`${this.chunksuploaded} chunks uploaded`);
  //         accepted = true;
  //         accept();
  //       }
  //       else {
  //         //console.warn('nothing uploaded yet');
  //       }
  //     }, 1000);
  //   });
  // }

  async stopRecording(restarting: boolean = false) {
    if (this.recordinguploadstartedinterval) {
      clearInterval(this.recordinguploadstartedinterval);
    }
    if (this.mediaRecorder && this.mediaRecorder.state === 'recording') {
      console.log('stopping recording...');
      this.mediaRecorder.stop();
      await this.recorderStopped();
    }

    if (!restarting) {
      this.recorderStarted = false;
    }
  }

  async recorderStopped() {
    return new Promise<void>((resolve, reject) => {
      const stoppedinterval = setInterval(() => {
        if (!this._recording) {
          console.log('recording stopped');
          clearInterval(stoppedinterval);
          resolve();
        }
      }, 100);
    });
  }
  
  async restartRecording(secondView: boolean) {
    if (this.recorderStarted) {
      await this.stopRecording(true);//TODO: we have to make sure that this._recording is not set to false
      await this.startRecording(secondView, this.allowExternalWebcam, true);
    }
  }

  async getMeetingAuth(requestId: string, meetingId: string){
    return await this.util.tryPost(`${environment.proctorServiceRootUrl}requestss3/getcandidateauth`, { name: this.name, username: this.loggedInUsername, company: this.company, requestId, meetingId },
      { headers: this.req_headers });
  }

  async logCandidateMeetingId(meetingid: string) {
    return await this.util.tryPost(`${environment.proctorServiceRootUrl}requestss3/logcandidatemeetingid`, { examId: this.examid, scheduleId: this.scheduleid, meetingId: meetingid },
      { headers: this.req_headers });
  }

  async getCandidateMeetingId() {
    return await this.util.tryGet(`${environment.proctorServiceRootUrl}requestss3/getcandidatemeetingid?examId=${this.examid}&scheduleId=${this.scheduleid}`,
      { headers: this.req_headers });
  }

  async logLastVideoUploadedTime(time: number, part: number, secondView: boolean){
    return await this.util.tryPost(`${environment.proctorServiceRootUrl}recordings3/loglastuploadtimes`, { examId: this.examid, scheduleId: this.scheduleid, time, part, secondView },
      { headers: this.req_headers });
  }

  async candidateSecondViewAuth(username: string, accessCode: string){
    return await this.util.tryPost(`${environment.proctorServiceRootUrl}requestss3/candidatesecondviewauth`, { examNo: username, accessCode: accessCode },
      { headers: this.req_headers });
  }

  async checkHostIsInMeeting(){

    const hostsocketids: any = await this.meetingService.getAllUsersFromBackend(this.meetingHandlerService.meetingid, this.meetingHandlerService.jwt, true).toPromise();

    if(hostsocketids && hostsocketids.socketids && Object.keys(hostsocketids.socketids).length > 0){
      return true;
    }
    else{
      return false;
    }
  }

  async getMeetingUserCount(){
    
    const allUsers: any = await this.meetingService.getAllUsersFromBackend(this.meetingHandlerService.meetingid, this.meetingHandlerService.jwt, false).toPromise();

    //adjust the code that checks for too many candidates to take into account that we now have double the user count
    const nonsecondviewsocketids = {};

    if(allUsers && allUsers.socketids){
      // return Object.keys(hostsocketids.socketids).length;

      for(let socketid in allUsers.socketids){
        const dataJson = allUsers.socketids[socketid].data;
        const data = JSON.parse(dataJson);
        if(data && !data.secondView){
          nonsecondviewsocketids[socketid] = allUsers.socketids[socketid];
        }
      }

      return Object.keys(allUsers.socketids).length;
    }
    else{
      return 0;
    }
  }

  async getProctorInfo() {
    const ret = await this.http.get<any>(`${environment.proctorServiceRootUrl}requestss3/getproctorinfo?examid=${encodeURI(this.examid?.toString())}&company=${encodeURI(this.company)}&username=${encodeURI(this.loggedInUsername)}&name=${encodeURI(this.name)}`).toPromise();

    if (this.isSecondViewProctor) {
      //we can't use AI proctoring in second view
      if (ret.proctorLevel == ProctorLevels.AiProctoredOnly) {
        console.log('downgrading proctor level to record only in second view proctor');
        ret.proctorLevel = ProctorLevels.RecordOnly;
      }
      else if (ret.proctorLevel == ProctorLevels.LiveProctorWithAiAssist) {
        console.log('downgrading proctor level to live proctored only in second view proctor');
        ret.proctorLevel = ProctorLevels.LiveProctoredOnly;
      }
    }

    return ret;
  }

  getCompany() {
    const location = window.location.hostname;
    const splitlocation = location.split('.');
    let subdomain_company = "";
    if (splitlocation.length >= 2) {
      subdomain_company = splitlocation[0];
      if (subdomain_company == 'www' || subdomain_company == 'proctor' || subdomain_company == 'proctee') {
        subdomain_company = '';
      }
    }
    else {
      subdomain_company = '';
    }
    return subdomain_company;
  }

  async getExamUrl() {
    let examurlservice = `${environment.proctorServiceRootUrl}requestss3/getexamurl?company=${this.company}`
    const ret = await this.http.get<any>(examurlservice).toPromise();
    return ret;
  }

  // private async getPassportUrl() {
  //   return await this.http.get<any>(`${environment.proctorServiceRootUrl}requests/getpassporturlbyexamid?examid=${encodeURI(this.examid)}&company=${encodeURI(this.company)}`).toPromise();
  // }

  // async getPassport(): Promise<Blob> {
  //   const Url = await this.getPassportUrl();
  //   return await this.http.get<any>(`${Url.passporturl}${this.loggedInUsername}&company=${encodeURI(this.company.toLowerCase())}&base64=${true}`).toPromise()
  //     .then(async (data) => {
  //       const passportBase64 = await fetch(`data:image/jpeg;base64,${data.imgdata}`);
  //       return await passportBase64.blob();
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       return null;
  //     });
  // }

  async getVideoStream(allowExternalWebcam: boolean, forcedDeviceId: string = undefined): Promise<MediaStream> {

    //let forcedDeviceId: string = undefined;
    if(this.isSecondViewProctor){
      //get a video stream that is not primaryViewDeviceId
      if(!this.isInteractiveSecondView){
        if(!this.secondViewDeviceLabel){
          throw new Error('secondViewDeviceLabel not set');
        }
        forcedDeviceId = await this.getDeviceId(this.secondViewDeviceLabel);
        if(!forcedDeviceId){
          throw new Error(`device '${this.secondViewDeviceLabel}' not found`);
        }
        //iterate over the devices and pick one that is not the primary view device
        //in this case, the user is only expected to have 2 webcams anyway
        //we will count on SEB to prevent virtual cameras
        
        // for(let i = 0; i < devices.length; i++){
        //   const device = devices[i];
        //   if(device.kind == 'videoinput' && device.label != this.primaryViewDeviceLabel && !this.isLikelyVirtualCamera(device.label)){
        //     forcedDeviceId = device.deviceId;
        //     break;
        //   }
        // }

        // if(!!this.primaryViewDeviceLabel && !forcedDeviceId){
        //   throw new Error('Unable to start second view. Reason: No compatible secondary webcam was found');
        // }
      }
      else{
        //TODO:
        //if it is the interactive second view, then we should iterate over all the facingMode: 'user' cameras and select the one with the widest view
        //we could also try to insist on landscape
      }
    }
    //console.log("start")
    if(this.videostream && ((this.videostream as any).trackended || this.videostream.getVideoTracks()[0].readyState == 'ended' || this.videostream.getAudioTracks()[0].readyState == 'ended')){
      //i don't want to stop the tracks because it looks like recording still works when readystate is ended
      // try{
      //   [...this.videostream.getVideoTracks(), ...this.videostream.getAudioTracks()].forEach((track) => {
      //     try{
      //       track.stop();
      //     }
      //     catch{}
      //   });
      // }
      // catch{}

      this.videostream = null;
    }

    if (!this.videostream) {
      //console.log({isSecondViewProctor: this.isSecondViewProctor, primaryViewDeviceId: this.primaryViewDeviceId})
      
      const videoConstraints: any = {
        height: { max: 240 },
        facingMode: 'user',
        frameRate: { ideal: this.isSecondViewProctor ? 15 : 30 }
      };
      
      if(forcedDeviceId){
        videoConstraints.deviceId = {exact: forcedDeviceId};
        delete videoConstraints.facingMode;
      }

      let stream: MediaStream;
      for(let i = 0; i < 3; i++){
        try {
          console.log('getting video with constraint: ', videoConstraints);

          stream = await navigator.mediaDevices.getUserMedia({
            video: videoConstraints,
            audio: true
          });

          [...stream.getAudioTracks(), ...stream.getVideoTracks()].forEach(track => {
            track.onended = () => {
              (stream as any).trackended = true;
              //this.stopPublishing(true);
            };
          });

          const videoSettings = stream.getVideoTracks()[0].getSettings();
          this.videoDeviceLabel = await this.getDeviceLabel(videoSettings.deviceId);

          if(!this.videoDeviceLabel){
            //in safari, the deviceid in the video track might be a device id that doesn't exist
            //no idea why this happens
            //but in that case, we'll need to just pick the first device
            const devices = await navigator.mediaDevices.enumerateDevices();
            for(let j = 0; j < devices.length; j++){
              if(devices[j].kind == 'videoinput'){
                this.videoDeviceLabel = devices[j].label;
                break;
              }
            }
          }

          console.log('new video stream set');
          console.log({videoSettings, videoDeviceLabel: this.videoDeviceLabel});
          //console.log("1");

          break;
        }
        catch(error){
          console.error(error);

          if(i == 0){
            delete videoConstraints.height;
          }
          else if(i == 1){
            delete videoConstraints.facingMode;
          }
          else{
            throw error;
          }
        }
      }
      
      this.videostream = stream;
    }

    const platform = ((navigator as any).userAgentData?.platform ?? navigator.platform);
    //for some reason, on windows, some devices show up in the browser as usb video device
    //even though the name in device manager shows an hp webcam
    //this might be an hp issue so we can only do this check on mac
    //This means on windows, we can only prevent external webcams using our version of SEB
    //And since we don't have our own version of SEB on mac, we will try to prevent it here
    if(typeof SafeExamBrowser !== 'undefined' && environment.isMac) {    
    const videoTrack: MediaStreamTrack = this.videostream.getVideoTracks()[0];
      if(videoTrack && !allowExternalWebcam){
        const settings = videoTrack.getSettings();
        const deviceId = settings.deviceId ?? '';

        const devices = await navigator.mediaDevices.enumerateDevices();

        for(let i = 0; i < devices.length; i++){
          const device = devices[i];
          if(device.kind == 'videoinput' && device.deviceId == deviceId){
            const deviceName = device.label;
            
            if(!this.isLikelyInbuiltWebcam(deviceName) && this.isLikelyExternalWebcam(deviceName)){
              [...this.videostream.getAudioTracks(), ...this.videostream.getVideoTracks()].forEach(track => {
                track.stop();
              });

              this.videostream = null;

              const errorString = `Unsupported webcam '${deviceName}' detected`;
              console.error(errorString);

              alert(errorString);

              throw new Error(errorString);
            }

            break;
          }
        }
      }
    }

    return this.videostream;
  }

  async sendCustomPrivateMessageToProctor(messageId: string, data: any) {
    //the room name is always "Proctor_{proctorsocketid}"
    //debugger;
    //const splitroomname = this.meetingHandlerService.currentRoom.split('_');
    //const proctorsocketid = splitroomname[1];
    await this.meetingHandlerService.sendCustomPrivateMessage(messageId, this.proctorSocketId, data);
  }

  // async startProctor(requestId: any, company: string) {
  //   return await this.http.post(`${environment.proctorServiceRootUrl}requests/startproctor`, { requestId, company }, { headers: this.req_headers }).toPromise();
  // }

  sleep(milliseconds) {
    return new Promise((resolve, reject) => {
      setTimeout(resolve, milliseconds);
    });
  }

  async aiFlagProctee(reason: string) {
    return this.http.post(`${environment.proctorServiceRootUrl}procteess3/aiflag`,
      { examid: this.examid, candidateno: this.loggedInUsername, reason: reason, company: this.company, examAttempt: this.attempt, scheduleid: this.scheduleid },
      { headers: this.req_headers }).toPromise();
  }

  // async getAIFlagConfig(): Promise<any> {
  //   return this.http.get(environment.proctorServiceRootUrl + `proctees/getaiflagconfig?examid=${encodeURI(this.examid)}&company=${encodeURI(this.company)}`).toPromise();
  // }

  

  async processRecording(time) {
    return this.http.post(`${environment.proctorServiceRootUrl}recording/processmediafile`,
      { examid: this.examid, candidateno: this.loggedInUsername, company: this.company, time: time, secondView: this.isSecondViewProctor },
      { headers: this.req_headers }).toPromise();
  }

  private isLikelyInbuiltWebcam(name: string): boolean {
    const builtInKeywords = [
        "Built-In",
        "Integrated",
        "HP Wide Vision",
        "HP TrueVision",
        "Lenovo EasyCamera",
        "ASUS USB2.0 Camera"
    ];

    for (const keyword of builtInKeywords) {
        if (name.toLowerCase().includes(keyword.toLowerCase())) {
            return true;
        }
    }
    return false;
  }

  private isLikelyVirtualCamera(name: string): boolean{
    const virtualKeywords = ["Virtual", "OBS", "Snap Camera", "ManyCam", "XSplit", "AlterCam", "mmhmm" ];

    for (const keyword of virtualKeywords) {
        if (name.toLowerCase().includes(keyword.toLowerCase())) {
            return true;
        }
    }
    return false;
  }

  private isLikelyExternalWebcam(name: string): boolean{
    return name.toLowerCase().includes('usb');
  }

  promises = new Map<number, any>();

  sendMessageToSecondViewIframe(message) {
    const iframe = this.secondViewIframeComponent.secondViewIframe.nativeElement.contentWindow;
    message.messageid = Date.now();
    iframe.postMessage(message, '*');
    return new Promise<any>((accept: any, reject: any) => {
      this.promises.set(message.messageid, [accept, reject]);
    });
  }

  secondViewProctorMessageListener(evt: any) {
    if (evt.data.messageid) {
      if (this.promises.has(evt.data.messageid)) {
        const fns = this.promises.get(evt.data.messageid);
        const acceptfn = fns[0];
        const rejectfn = fns[1];
        this.promises.delete(evt.data.messageid);

        if (evt.data.success) {
          acceptfn(evt.data);
        }
        else {
          rejectfn(evt.data);
        }
      }
    }
  }

  public async stopProctorEventHandler(data: any) {
    this.secondViewPreference = undefined;
    if (this.chatModalRef) {
      this.chatModalRef.dismiss();
    }

    if (this.startSecondViewProctor) { //if we started the second view proctor, then we have to stop it
      //TODO: so that this works with the external proctor on mobile device, we have to inform the user to stop the proctoring on the external device
      await this.sendMessageToSecondViewIframe({ ...data, operation: 'stop'  });
    }

    this.started = false;

    if (this.proctorInfo && (this.proctorInfo.proctorLevel == ProctorLevels.LiveProctoredOnly || this.proctorInfo.proctorLevel == ProctorLevels.LiveProctorWithAiAssist)) {
      this.meetingHandlerService.leaving = true;
      this.meetingHandlerService.stopConnecting = true;
      this.stopConnecting = true;
      //this.connecting = false;
      try {
        console.log('cbt stop');
        //this.meetingService.selfDisconnectAndDeassign(this.meetingHandlerService.domain, this.meetingHandlerService.jwt, this.meetingHandlerService.clientInstanceId, false);
        this.meetingHandlerService.leaving = true;
        await this.meetingHandlerService.disconnect();
        await this.meetingHandlerService.destroy(true);
      }
      catch (error) {
        console.error(error);
      }
    }

    try {
      console.log('stopping publishing in stop operation');
      let stopPublishing = true;
      // if(evt.data.reason === 'Not Publishing'){
      //   stopPublishing = false;
      // }
      await this.stopPublishing(stopPublishing);
      this.aiProctorService.stopAiProctor();
    }
    catch (error) {
      console.error(error);
    }

    this.aiProctorService.stopAiProctor();
  }

  async getDeviceLabel(deviceId: string): Promise<string>{
    const devices = await navigator.mediaDevices.enumerateDevices();
    for(let i = 0; i < devices.length; i++){
      if(devices[i].deviceId == deviceId){
        return devices[i].label;
      }
    }
    return null;
  }

  async getDeviceId(deviceLabel: string): Promise<string>{
    const devices = await navigator.mediaDevices.enumerateDevices();
    for(let i = 0; i < devices.length; i++){
      if(devices[i].label == deviceLabel){
        return devices[i].deviceId;
      }
    }
    return null;
  }

  async getWidestCameraDevice(videoConstraints: any): Promise<MediaDeviceInfo>{
    //first make sure we have permissions
    const stream = await navigator.mediaDevices.getUserMedia({video: true, audio: true});
    [...stream.getVideoTracks(), ...stream.getAudioTracks()].forEach((track) => {
      track.stop();
    });

    if(!videoConstraints){
      videoConstraints = {};
    }
    const devices = await navigator.mediaDevices.enumerateDevices();
    let widestAspectRatio = 0;
    let widestDevice: MediaDeviceInfo = null;
    for(let i = 0; i < devices.length; i++){
      if(devices[i].kind == 'videoinput'){
        const deviceId = devices[i].deviceId;

        try{
          const videoTracks = (await navigator.mediaDevices.getUserMedia({video: {deviceId: {exact: deviceId}, ...videoConstraints}, audio: false}))?.getVideoTracks();

          const settings = videoTracks[0]?.getSettings();

          if(settings){
            const aspectRatio = settings.aspectRatio;

            if(aspectRatio > widestAspectRatio){
              widestAspectRatio = aspectRatio;
              widestDevice = devices[i];
            }
          }
        }
        catch(error){
          console.warn(`unable to check settings for device: `, devices[i]);
          console.error(error);
        }
      }
    }

    if(!environment.production){
      console.log('widest camera: ', widestDevice);
    }

    return widestDevice;
  }

  public async startProctoringEventHandler(data: any) {
    this.prevenstart = { preventstart: false, reasons: [] };
    await this.stopPublishing(false);
    this.aiProctorService.stopAiProctor();

    this.isSecondViewProctor = data.isSecondViewProctor ?? false;
    this.isInteractiveSecondView = false;
    this.examid = data.examid;
    this.examdesc = data.examdesc;
    this.loggedInUsername = data.username;
    this.name = data.name;
    this.attempt = data.attempt;
    //this.proctorService.overrideai = data.overrideai;
    this.passportversion = data.passportversion;
    this.passporttype = data.passporttype;
    this.aiCheckPhotoBeforeStart = !this.isSecondViewProctor && data.aiCheckPhotoBeforeStart;
    this.passporturl = data.passporturl;
    this.scheduleid = data.scheduleid;
    this.allowExternalWebcam = (!this.isSecondViewProctor && data.allowExternalPrimaryWebcam) || (this.isSecondViewProctor && data.allowExternalSecondViewWebcam);
    this.allowExternalSecondViewWebcam = data.allowExternalSecondViewWebcam;
    this.secondViewRequired = data.secondViewRequired ?? false;
    this.startSecondViewProctor = data.startSecondViewProctor ?? false;
    this.primaryViewDeviceLabel = data.primaryViewWebcamDeviceLabel;
    this.secondViewDeviceLabel = data.secondViewDeviceLabel;
    this.stopConnecting = false;
    //get proctor info
    this.proctorInfo = await this.getProctorInfo();

    const external = !!data.external;

    if(external){
      this.scheduleid = await this.registerExternalCandidate();
    }
    
    if(!environment.production){
      console.log(`proctorInfo: `, this.proctorInfo);
      console.log('data:', data);
    }
    
    if (this.startSecondViewProctor) {
      //allowExternalSecondViewWebcam
      // if (!data.allowExternalSecondViewWebcam) {
      //   //the candidate's device can't use the internal webcam for both internal and external
      //   throw new Error('External second view webcam not allowed');
      // }
      //we have to find out which device id has already been used for the primary video stream so that we don't select it for the second view
      const stream = await this.getVideoStream(this.allowExternalWebcam);

      const videoTrack = stream.getVideoTracks()[0];
      if (!videoTrack) {
        throw new Error('No video track found in proctoring video stream');
      }
      //const settings = videoTrack.getSettings();
      // const primaryViewWebcamDeviceLabel = this.videoDeviceLabel;
      // const secondViewIframeComponent = this.secondViewIframeComponent;
  
      
      await this.initiateAndConfirmSecondView(data);
      
    }

    switch (this.proctorInfo.proctorLevel) {
      case ProctorLevels.RecordOnly:
        await this.recordOnly(this.allowExternalWebcam);
        break;
      case ProctorLevels.AiProctoredOnly:
        await this.aiProctorOnly(this.aiCheckPhotoBeforeStart, this.allowExternalWebcam);
        break;
      case ProctorLevels.LiveProctoredOnly:
        await this.liveProctorOnly(this.aiCheckPhotoBeforeStart, this.allowExternalWebcam);
        break;
      case ProctorLevels.LiveProctorWithAiAssist:
        await this.liveProctorWithAiAssist(this.aiCheckPhotoBeforeStart, this.allowExternalWebcam);
        break;
      default:
        throw new Error('Proctor level not supported');
    }

    if(this.isSecondViewProctor){
      setInterval(async () => {
        if(this.proctorInfo.proctorLevel == ProctorLevels.LiveProctoredOnly || this.proctorInfo.proctorLevel == ProctorLevels.LiveProctorWithAiAssist){
        const currentProcteeMeetingId = (await this.getCandidateMeetingId())?.liveProctorMeetingId;

        if(this.meetingHandlerService.meetingid && this.meetingHandlerService.meetingid != currentProcteeMeetingId && !this.meetingHandlerService.connecting){
          console.log('try to connect second view to the right meeting');
          await this.meetingHandlerService.disconnect();
          await this.meetingHandlerService.destroy();
          this.handleDisconnectFromLiveProctor();
        }
      }
      }, 10 * 1000);
      
    }
  }

  private async liveProctorWithAiAssist(aiCheckPhotoBeforeStart: boolean, allowExternalWebcam: boolean) {
    await this.startRecording(this.isSecondViewProctor, allowExternalWebcam, false);
    await this.startLiveProctor(true, aiCheckPhotoBeforeStart, allowExternalWebcam);
  }

  private async liveProctorOnly(aiCheckPhotoBeforeStart: boolean, allowExternalWebcam: boolean) {
    await this.startRecording(this.isSecondViewProctor, allowExternalWebcam, false);
    await this.startLiveProctor(false, aiCheckPhotoBeforeStart, allowExternalWebcam);
  }

  private async aiProctorOnly(aiCheckPhotoBeforeStart: boolean, allowExternalWebcam: boolean) {
    await this.startRecording(this.isSecondViewProctor, allowExternalWebcam, false);
    await this.startAiProctor(aiCheckPhotoBeforeStart, allowExternalWebcam);
  }

  private async recordOnly(allowExternalWebcam: boolean) {
    await this.startRecording(this.isSecondViewProctor, allowExternalWebcam, false);
  }

  async startLiveProctor(aiAssist: boolean, aiCheckPhotoBeforeStart: boolean, allowExternalWebcam: boolean) {
    if (!this.prevenstart?.preventstart) {
      let aiPromise: Promise<void>;
      if (aiAssist) {
        aiPromise = this.startAiProctor(aiCheckPhotoBeforeStart, allowExternalWebcam);
      }
      else if (aiCheckPhotoBeforeStart) {//(!aiAssist){
        //we don't want to check this if we are already doing ai assist because ai proctor part will have done this check 
        console.log('checking for AI to allow start');
        const videoStream = await this.getVideoStream(allowExternalWebcam) as MediaStream;

        await this.aiProctorService.startAIProctorVideo(videoStream);
        aiPromise = this.checkAndSetAIPreventStart(true);
      }
      else{
        aiPromise = Promise.resolve(null);
      }

      let passporturl = this.getPassportUrl();

      console.log('waiting for AI promise');
      await aiPromise;//we want to wait until AI says we can start before we go ahead and start connecting to the live meeting server
      console.log('AI promise has returned');

      const preventStart = this.prevenstart;
      if (!preventStart?.preventstart) {
        //We no longer want the candidate to have to wait until a connection is successful so we just keep trying forever
        //const domain = await this.meetingHandlerService.getMeetingServer();
        console.log('calling findAndConnectToMeetingUntilSuccessful');

        //we can't wait for this because there might actually be no proctor so no meeting to connect to
        const _connect = () => {
          this.findAndConnectToMeetingUntilSuccessful(this.meetingHandlerService.defaultRoom, { examid: this.examid, passporturl: passporturl, secondView: this.isSecondViewProctor }).then(async (successful) => {
            if(successful === true){
              console.log('connected successfully');
              //debugger;
              this.started = true;
              await this.publishVideo();
            }
            else{
              console.log('did not connect');
              //means we've asked it to stop connecting
            }
          }).catch((error) => {
            console.error(error);
            _connect();//we should never get here because findAndConnectToMeetingUntilSuccessful catches everthing
          });
        }

        _connect();
      }
      else{
        throw new Error(`Proctor Start Prevented. Reason: ${this.prevenstart?.reasons[0]}`);
      }
    }
  }

  private handleMeetingEvents() {
    this.meetingHandlerService.participantProducerRemovedSubject.subscribe(params => {
      const { socketId, producerId, kind } = params;
      if (kind === 'audio') {
        if (this.audios[socketId]) {
          delete this.audios[socketId][producerId];
          if (Object.keys(this.audios[socketId]).length == 0) {
            delete this.audios[socketId];
          }
        }
      }
    });
    //this.meetingHandlerService.screenSharePublishedSubject.subscribe(() => this.resized());
    this.meetingHandlerService.participantAddedSubject.subscribe((participant: Participant) => {
      //not needed
      if(participant.host && participant.username.startsWith('Proctor_')) {
        this.notifyOfProctorPresence(true, participant.socketid);
      }
    });
    this.meetingHandlerService.participantRemovedSubject.subscribe(async (socketid: string) => {
      //if the candidate is in a proctor's room, and that proctor leaves, candidate should go to the default room

    });
    this.meetingHandlerService.participantBeingRemovedSubject.subscribe(async (socketid: string) => {
      
      //if the host has left, leave the meeting and connect to another
      if (this.meetingHandlerService.participantsMap.has(socketid)) {
        const participant = this.meetingHandlerService.participantsMap.get(socketid);

        //if the host has left or we are in second view and the main participant leaves
        if(participant.host || (participant.username == this.meetingHandlerService.meParticipant.username && !participant.data.secondView && this.isSecondViewProctor)){
        //console.log(this.meetingHandlerService.participantsMap.get(socketid));
          this.handleDisconnectFromLiveProctor();
        }
      }
      

    });
    this.meetingHandlerService.meetingEndedSubject.subscribe(async () => {
      this.handleDisconnectFromLiveProctor();
    });
    this.meetingHandlerService.producerTypeUnavailableSubject.subscribe(() => {
      //not needed
    });
    this.meetingHandlerService.takeAttendanceSubject.subscribe(() => {
      //not needed
    });
    this.meetingHandlerService.reconnectingSubject.subscribe(async () => {
      //not needed
    });
    this.meetingHandlerService.reconnectedSubject.subscribe(() => {
      //not needed
    });
    this.meetingHandlerService.disconnectedSubject.subscribe(async () => {
      console.log('stopping publishing in disconnect subject');
      if (this.chatModalRef?.componentInstance?.chat) {
        this.chatModalRef.componentInstance.chat = [];
      }
      
      //this.aiProctorService.stopAiProctor();
      this.handleDisconnectFromLiveProctor();

      //if we're reconnecting, reconnect to the default room
      //this.meetingHandlerService.currentRoom = this.meetingHandlerService.defaultRoom;
      
      // if(!this.meetingHandlerService.leaving){
      //   this.findAndConnectToMeetingUntilSuccessful(this.meetingHandlerService.defaultRoom, { examid: this.proctorService.examid, passporturl: passporturl });
      // }
    });
    // this.meetingHandlerService.toastrError.subscribe(message => {
    //   this.toastr.error(message);
    // });
    // this.meetingHandlerService.toastrWarning.subscribe(message => {
    //   this.toastr.warning(message);
    // });
    // this.meetingHandlerService.toastrSuccess.subscribe(message => {
    //   this.toastr.success(message);
    // });
    this.meetingHandlerService.notifySubject.subscribe((message) => {
      console.log('notification: ', message);
      const messageid = message.messageid;
      const data = message.data;

      switch (messageid) {
        case NotificationMessages.microphonedisabledbyhost:

          break;
        case NotificationMessages.notyetenabledtospeak:

          break;
        case NotificationMessages.webcamdisabledbyhost:

          break;
        case NotificationMessages.enabledtospeak:

          break;
        case NotificationMessages.enteredroom:

          break;
        case NotificationMessages.brokenout:

          break;
        case NotificationMessages.errorproducing:

          break;
        default:
          this.toastr.warning(`Unknown message id ${messageid}`);
      }
    });
    this.meetingHandlerService.participantHandRaisedSubject.subscribe(participant => {
    });
    this.meetingHandlerService.enteredRoomSubject.subscribe(() => {
      
    });
    this.meetingHandlerService.connectedSubject.subscribe(async (first: boolean) => {
      console.log('connected subject handler. first: ' + first);
      
      if (!first) {
        await this.publishVideo();
        //if we have just reconnected, start the ai proctor, but don't check for prevent start        
      }
      if (this.proctorInfo.proctorLevel == ProctorLevels.LiveProctorWithAiAssist) {
        await this.startAiProctor(first, this.allowExternalWebcam);
      }
    });
    this.meetingHandlerService.handDroppedSubject.subscribe((message) => {
      const socketId = message.socketId;
      const remoteId = message.remoteId; //the user who dropped the hand
      const unlocked = message.unlocked;
      const timeout = message.timeout;

      // if(socketId == this.meetingHandlerService.socket.id){
      //   this.meetingHandlerService.handraised = false;
      //   if(timeout || (socketId != remoteId && !unlocked)){
      //     //if the user didn't drop his own hand, and it wasn't dropped as a result of unlocking then notify him
      //     this.toastr.warning('Hand Dropped');
      //   }
      //   else if(unlocked && this.meetingHandlerService.meParticipant.unlocked){
      //     //if the user had raised his hand and was then unlocked by the host, he should immediately start sending audio
      //     this.settings.enableMicrophone = true;
      //     this.meetingHandlerService.publishAudio(false);
      //   }
      // }
      // else{
      //   if(this.meetingHandlerService.participantsMap.has(socketId)){
      //     const participant = this.meetingHandlerService.participantsMap.get(socketId);
      //     participant.handRaised = false;
      //   }
      // }
    });
    // this.meetingHandlerService.remoteProducerPausedSubject.subscribe((message) => {
    // });
    // this.meetingHandlerService.remoteProducerResumedSubject.subscribe((message) => {
    // });
    this.meetingHandlerService.videoConsumerRemovedSubject.subscribe((socketId) => {
    });
    this.meetingHandlerService.audioConsumerRemovedSubject.subscribe((socketId) => {
    });

    this.meetingHandlerService.screenShareVideoProducerAddedSubject.subscribe(async (data: any) => {
      // const {socketid, producerid, kind} = data;
      // if(this.meetingHandlerService.screenShareConsumer && this.previousScreenShareParticipantSocketId){
      //   await this.meetingHandlerService.closeConsumer(this.previousScreenShareParticipantSocketId, this.meetingHandlerService.screenShareConsumer);
      //   this.previousScreenShareParticipantSocketId = socketid;
      // }
      // const participant = this.meetingHandlerService.participantsMap.get(socketid);
      // this.meetingHandlerService.screenShareConsumer = (await this.meetingHandlerService.createConsumer(socketid, producerid, kind)).consumer;
      // this.meetingHandlerService.setPreferredConsumerSpatialLayer(socketid, this.meetingHandlerService.screenShareConsumer.id, 1);
      // this.meetingHandlerService.screenShareParticipantSocketId = socketid;
      // this.meetingHandlerService.screenShareParticipantUsername = participant.username;
      // this.meetingHandlerService.screenShareParticipantName = participant.name;
      // this.meetingHandlerService.participantScreenShareAvailable = true;
      // this.meetingHandlerService.focusedMode = true;
      // this.meetingHandlerService.resumeConsumer(participant.socketid, this.meetingHandlerService.screenShareConsumer, false);
      // this.resized();
      // this.screensharevideo.nativeElement.srcObject = new MediaStream([this.meetingHandlerService.screenShareConsumer.track]);
    });

    this.meetingHandlerService.remoteAudioProducerAddedSubject.subscribe(async (data: { socketid: string; producerid: string; kind: string; private: boolean; }) => {
      const participant = this.meetingHandlerService.findParticipant(data.socketid);
      if (participant && participant.host) { //for proctoring, we are only interested in the proctor's audio stream. ideally, we don't even want to be notified of the other candidates' streams
        const createConsumerInfo = await this.meetingHandlerService.createConsumer(data.socketid, data.producerid, 'audio', false, false);
        const audioConsumer = createConsumerInfo.consumer;

        const audio = new Audio();
        audio.autoplay = true;
        audio.srcObject = new MediaStream([audioConsumer.track]);

        if (!this.audios[data.socketid]) {
          this.audios[data.socketid] = {};
        }
        this.audios[data.socketid][data.producerid] = audio;
      }
    });
    this.meetingHandlerService.remoteVideoProducerAddedSubject.subscribe(async (data) => {
      const { socketid, producerid } = data;
    });
    this.meetingHandlerService.customMessageSubject.subscribe(async (data) => {
      switch (data.messageId) {
        case 'privateChatMessage':
          if (!this.chatModalRef) {
            this.chatModalRef = this.modalService.open(ChatmodalComponent, {
              backdrop: 'static',
              keyboard: false,
              size: 'md',
              centered: false,
              ariaLabelledBy: 'chatModalTitle',
              ariaDescribedBy: 'chatModalDesc',
            });
            
            this.chatModalRef.result.finally(() => {
              this.examIframeComponent?.examIframe.nativeElement.contentWindow.postMessage({ event: 'chatclosed' }, '*');
              this.chatModalRef = null;
            });

            // Optional: Notify iframe chat is open
            this.examIframeComponent?.examIframe.nativeElement.contentWindow.postMessage({ event: 'chatopened' }, '*');
          }
          
          const chatInstance = this.chatModalRef.componentInstance;
          chatInstance.chatOpened = true;
          chatInstance.addChatMessage(data.message.message, false, data.private);
          break;
        case 'privateChatClosed':
          //doesn't make sense to close the chat modal when the proctor closes his own...rather, the text area will be disabled
          if (this.chatModalRef) {
            const chatInstance = this.chatModalRef.componentInstance;
            chatInstance.chatOpened = false;
            chatInstance.chattextarea.nativeElement.value = '';
            chatInstance.addChatMessage('&lt;&lt;Chat Ended. Please close chat to proceed&gt;&gt;', false, true);
          }
          break;
        case 'proctorSocketId':
          this.notifyOfProctorPresence(true, data.message.proctorSocketId);
          break;
        case 'restartPublish':
          await this.stopPublishing(true);
          this.aiProctorService.stopAiProctor();
          await this.util.sleep(2000);//wait for 2 seconds so that the webcam isn't overwhelmed
          await this.publishVideo();
          //if we have just republishing, start the ai proctor, but don't check for prevent start
          if (this.proctorInfo.proctorLevel == ProctorLevels.LiveProctorWithAiAssist) {
            await this.startAiProctor(false, this.allowExternalWebcam);
          }
          break;
        case 'pauseStatusChanged':
          this.examIframeComponent?.examIframe.nativeElement.contentWindow.postMessage({ event: 'pauseStatusChanged', ...data.message }, '*');
        default:

      }
    });
  }

  async findAndConnectToMeetingUntilSuccessful(room: string = null, participantData: any): Promise<boolean> {
    const checkMeetingForHost = () => {
      let hostFound = false;
      for (let kvpair of this.meetingHandlerService.participantsMap) {
        if (kvpair[1].host) {
          hostFound = true;
          break;
        }
      }
      return hostFound;
    }

    const checkForSecondViewPrimaryParticipant = () => {
      let primaryViewParticipantFound = false;
      for(let x of this.meetingHandlerService.participantsMap){
        const socketid = x[0];
        const participant = x[1];
        
        if(participant.username == this.loggedInUsername && !participant.data.secondView){
          primaryViewParticipantFound = true;
          break;  
        }
      }
      return primaryViewParticipantFound;
    };

    if(this.checkForHostsInterval){
      clearInterval(this.checkForHostsInterval);
      this.checkForHostsInterval = undefined;
    }
    if(this.checkForSecondViewParticipantInterval){
      clearInterval(this.checkForSecondViewParticipantInterval);
      this.checkForSecondViewParticipantInterval = undefined;
    }
    if(this.connecting){
      return false;
    }
    this.connecting = true;
    let successful = false;
    while(!successful && !this.stopConnecting){
      try{
        

        //subscribe to meeting events
        
        const proctorInfo = await this.getProctorInfo();
        this.proctorInfo = proctorInfo;

        //debugger;

        let meetings: any[] = proctorInfo.meetings;

        

        if(this.isSecondViewProctor){
          //get the meeting the candidate is in and limit the meetings array to just that

          const currentProcteeMeetingId = (await this.getCandidateMeetingId())?.liveProctorMeetingId;

          let meeting;
          for(let i = 0; i < meetings.length; i++){
            if(meetings[i].meetingId == currentProcteeMeetingId){
              meeting = meetings[i];
              break;
            }
          }

          if(meeting){
            meetings = [meeting];
          }
          else{
            meetings = [];
          }

          
          
          //after connecting, we have to ensure that both front view and back view stay in the same meeting via both events and interval checks
          //find somewhere on the cbt frontend interface to show the rear view
        }

        if(meetings.length == 0){
          console.log(`No meetings found for proctor request ${proctorInfo.requestId}`);
        }

        while(meetings.length > 0 && !this.stopConnecting) {
          //randomly pick a meeting so as to try to evenly distribute the candidates accross meetings

          const i = Math.floor(Math.random() * meetings.length);

          try{
            this.destroy();
            //console.log('destroying meeting handler service')
            await this.meetingHandlerService.destroy(false);//we want to make sure we reset everything in the meeting service because this could be a second exam the candidate is starting

            this.handleMeetingEvents();//this must happen after resetting the meeting service


            const meeting = meetings[i];

            this.meetingHandlerService.meetingid = meeting.meetingId;

            console.log(`Trying meeting '${meeting.meetingId}'`);

            if(!this.meetingAuths[meeting.meetingId]){
              //we don't want to generate auths multiple times for the same meeting
              //so we just ensure that we cache the auths in case we come back to try this meeting again
              const authObj = await this.getMeetingAuth(proctorInfo.requestId, meeting.meetingId);
              this.meetingAuths[meeting.meetingId] = authObj.auth;
            }

            const jwt = this.meetingAuths[meeting.meetingId];
            //todo:
            //generate the jwt for that meeting
            this.meetingHandlerService.jwt = jwt;

            //get meeting info
            const meetinginfo = await this.meetingService.getMeeting(meeting.meetingId).toPromise();

            if(meetinginfo.started && !meetinginfo.ended) {
              // if(!this.meetingHandlerService.meetingid){
              //   debugger;
              // }
              await this.meetingHandlerService.init();
              this.meetingHandlerService.leaving = false;

              const hostInMeeting = await this.checkHostIsInMeeting();
              let userCount = 0;

              if(hostInMeeting){
                userCount = await this.getMeetingUserCount();
              }

              if(hostInMeeting && userCount < this.maximumMeetingUsers){
                //await this.meetingService.requestMeetingServer(this.meetingHandlerService.meetingid, this.meetingHandlerService.jwt, this.meetingHandlerService.clientInstanceId, false).toPromise();
                const connected = await this.meetingHandlerService.connectToMeetingUntilSuccessful(true, room, participantData, this.meetingHandlerService.numberOfConnectionAttemptsBeforeRequestingNewServer);//we're not trying only once because it may take a few attempts just to get a server

                if(connected){
                  
                    //the host may have left after we last checked and before the connection was established so we need to check again
                    //this time, we can use the current participants
                    const hostFound = checkMeetingForHost();
                    const primaryViewParticipantFound = checkForSecondViewPrimaryParticipant();

                    if(hostFound && (!this.isSecondViewProctor || primaryViewParticipantFound) && this.meetingHandlerService.participantsMap.size < this.maximumMeetingUsers){
                      console.log(`SELECTED MEETING '${meeting.meetingId}'`);
                      successful = true;

                      if(!this.isSecondViewProctor){
                        try{
                          await this.logCandidateMeetingId(meeting.meetingId);
                          // if(this.startSecondViewProctor){
                          //   this.signalSecondViewToConnectToLiveProctor(this.secondViewIframeComponent, meeting.meetingid);
                          // }
                        }
                        catch(error){
                          console.error(error);
                          //second view can't work if this doesn't succeed so we just throw the error again
                          //if we don't need second view, this logging is just a nice to have
                          if(this.secondViewRequired){
                            throw error;
                          }
                        }
                      }
                      else{
                        //if we are a second view proctor, we want to make sure the primary view participant is here
                        //else, we leave

                        this.checkForSecondViewParticipantInterval = setInterval(() => {
                          if(!checkForSecondViewPrimaryParticipant()){
                            console.log(`Second view primary participant not found in meeting '${meeting.meetingId}' (found in interval checks)`);
                            this.handleDisconnectFromLiveProctor();
                          }
                        }, 10000);
                      }

                      this.checkForHostsInterval = setInterval(async () => {
                        const hostFound = checkMeetingForHost();
                        if(!hostFound){
                          console.log(`No host in meeting '${meeting.meetingId}' (found in interval checks)`);
                          this.handleDisconnectFromLiveProctor();
                        }
                      }, 10000);

                      break;
                    }
                    else{
                      try{
                        await this.meetingHandlerService.disconnect();
                        await this.meetingHandlerService.destroy();
                      }
                      catch(error){
                      }
                      if(!hostFound){
                        console.log(`No host in meeting '${meeting.meetingId}'`);
                      }
                      if(this.isSecondViewProctor && !primaryViewParticipantFound){
                        console.log(`Second view primary participant not found in meeting '${meeting.meetingId}'`);
                      }
                      if(this.meetingHandlerService.participantsMap.size >= this.maximumMeetingUsers){
                        console.log(`Too many users (${this.meetingHandlerService.participantsMap.size}) users in meeting '${meeting.meetingId}' (After connection)`);
                      }
                      console.log(`Will exit meeting '${meeting.meetingId}' (After connection)`);
                    }
                }
                else{
                  console.log(`Failed to connect to meeting '${meeting.meetingId}'`);
                }
              }
              else{
                console.log(`No host in meeting '${meeting.meetingId}' or too many users (${userCount} users)`);
              }
            }
            else{
              console.log(`Meeting ${meetinginfo.meetingId} has ended or hasn't been started`);
            }
          }
          catch(error){
            console.log(`Error at meeting '${this.meetingHandlerService.meetingid}'`);
            console.error(error);
          }
          finally{
            meetings.splice(i, 1);
            if(!successful){
              if(this.meetingHandlerService.meetingid && this.meetingHandlerService.jwt && this.meetingHandlerService.clientInstanceId){
                this.meetingService.deassignMeetingServer(this.meetingHandlerService.meetingid, this.meetingHandlerService.jwt, this.meetingHandlerService.clientInstanceId, false);
              }
              //this.meetingHandlerService.clientInstanceId = '';
              await this.util.sleep(1000);
            }
          }
        }
      }
      catch(error){
        console.error(error);
      }

      if(!successful){
        await this.util.sleep((this.isSecondViewProctor ? 10 : 30) * 1000);//if we've gone thorugh all the available meetings, we should just wait 30 seconds before trying again
        //second view proctors don't wait as long because we already know which meeting they should join (assuming the main view has already joined the meeting)
        //they don't need to do all the checks to pick a meeting
      }
      
    }

    this.connecting = false;
    return successful;

    
    //in a loop
    //get proctor info to get a list of enabled meetings
    //pick on at random
    //make 1 connection attempt to connect to that meeting
    //confirm that the meeting hasn't ended and that there's a host in that meeting.
    //if we can't connect or there is no host in that meeting, disconnect and desssign from that meeting
      //remove that meeting from the list and try again
  }

  

  public async startAiProctor(checkPreventStart: boolean, allowExternalWebcam: boolean) {
    const videoStream = await this.getVideoStream(allowExternalWebcam) as MediaStream;
    if (this.aiProctorService.stopped) {
      await this.aiProctorService.startAiProctor(videoStream, !this.aiCheckPhotoBeforeStart, this.attempt, this.examid, this.passportversion, this.passporttype, this.passporturl, this.loggedInUsername, this.scheduleid, this.company);
    }
    const cbtWindow = this.examIframeComponent?.examIframe.nativeElement.contentWindow;
    this.aiProctorService.onImageAnalysis.subscribe((analysis) => {
      if (analysis && this.meetingHandlerService.isMediasoupControlSocketConnected()) {
        console.log('image analysis: ', analysis);
        const { brightnessAnalysis, faceAnalysis, penaltyResponse, overrideai } = analysis;

        if (brightnessAnalysis == 'low') {
          cbtWindow.postMessage({ event: 'onLowLight', warning: `The room appears too dark. Please ensure you are in a brightly lit room.`, overrideai: overrideai }, '*');
          // cbtWindow.postMessage({ event: 'onLowLight', warning: `You have been flagged for ${display}`  }, '*');
          if (this.proctorInfo.proctorLevel === ProctorLevels.LiveProctorWithAiAssist) {
            try{
              this.meetingHandlerService.sendCustomMessage("lowLight", { reason: "Low light detected" });
            }
            catch(error){
              console.log(error);
            }
          }
        }
        // else if (brightnessAnalysis == 'high') {
        //   cbtWindow.postMessage({ event: 'onHighIntensityLight', warning: `The light behind you is too bright. Please ensure you are not backing the light`,overrideai:overrideai }, '*');
        //   // cbtWindow.postMessage({ event: 'onHighIntensityLight', warning: `You have been flagged for ${display}` }, '*');
        //   if(this.proctorInfo.proctorLevel === ProctorLevels.LiveProctorWithAiAssist){
        //     this.meetingHandlerService.sendCustomMessage("highIntensityLight", { reason: "High intensity light detected" });
        //   }
        // }

        if (faceAnalysis.noFace) {
          cbtWindow.postMessage({ event: 'onNoFace', warning: `We can't see your face. Please ensure you are facing your camera, and that you are in a brightly lit room. Also ensure you are not backing the light or an open window`, overrideai: overrideai }, '*');
          // cbtWindow.postMessage({ event: 'onNoFace', warning: `You have been flagged for ${display} `}, '*');
          if (this.proctorInfo.proctorLevel === ProctorLevels.LiveProctorWithAiAssist) {
            try{
              this.meetingHandlerService.sendCustomMessage("noFace", { reason: "No face detected" });
            }
            catch(error){
              console.log(error);
            }
          }
        }
        else {
          if (faceAnalysis.multipleFaces) {
            cbtWindow.postMessage({ event: 'onMultipleFaces', warning: `We can see multiple people. Please ensure you are the only one in the room while taking the exam`, overrideai: overrideai }, '*');
            // cbtWindow.postMessage({ event: 'onMultipleFaces', warning: `You have been flagged for ${display} ` }, '*');
            if (this.proctorInfo.proctorLevel === ProctorLevels.LiveProctorWithAiAssist) {
              try{
                this.meetingHandlerService.sendCustomMessage("multipleFaces", { reason: "Multiple faces detected" });
              }
              catch(error){
                console.log(error);
              }
            }
          }
          if (faceAnalysis.candidateFaceIsNotAMatch) {
            cbtWindow.postMessage({ event: 'onCandidateFaceMatchChange', warning: `We can't see you clearly. Please ensure you are facing your camera, and that you are in a brightly lit room. Also ensure that you are using a recent picture.`, overrideai: overrideai }, '*');
            // cbtWindow.postMessage({ event: 'onCandidateFaceMatchChange', warning: `You have been flagged for ${display} ` }, '*');
            if (this.proctorInfo.proctorLevel === ProctorLevels.LiveProctorWithAiAssist) {
              try{
                this.meetingHandlerService.sendCustomMessage("candidateFaceMismatch", { reason: "Candidate's face does not match the face on record" });
              }
              catch(error){
                console.log(error);
              } 
            }
          }
        }

        if (penaltyResponse?.length > 0) {
          this.aiProctorService.sendpenaltynotification(penaltyResponse, cbtWindow)
        }
      }
    });

    this.aiProctorService.onNoiseAnalysis.subscribe((noiseLevel) => {
      //cbtWindow.postMessage({ event: 'onNoise', warning: `The room appears to be noisy. Please ensure you are in a quiet room.` }, '*');
      if (this.proctorInfo.proctorLevel === ProctorLevels.LiveProctorWithAiAssist && this.meetingHandlerService.isMediasoupControlSocketConnected()) {
        try{
          this.meetingHandlerService.sendCustomMessage("noise", { reason: "Noise detected" });
        }
        catch(error){
          console.log(error);
        }
      }
      this.aiFlagProctee(AIFlags.Noise);
    })

    console.log('checkPreventStart: ', checkPreventStart);
    if (checkPreventStart) {
      await this.checkAndSetAIPreventStart(false);
    }
  }

  private async checkAndSetAIPreventStart(force: boolean) {
    const prevenstart = await this.aiProctorService.aiPreventExamStart(force, this.attempt, this.examid, this.passportversion, this.passporttype, this.passporturl, this.loggedInUsername, this.scheduleid, this.company);

    //console.log('prevent start: ', prevenstart);

    if (prevenstart.preventstart) {
      this.prevenstart = prevenstart;
    }
  }

  getPassportUrl() {
    return this.passportversion > 0 ? `${environment.s3passportbucketurl}${this.company.toLocaleLowerCase()}/passports/${this.loggedInUsername}_${this.passportversion}.${this.passporttype}` : this.passporturl;
  }

  handleDisconnectFromLiveProctor() {
    //we have deliberately left this method non-async 
    //that could change in the future, but it should be for good reason
    if(!this.isSecondViewProctor){
      this.logCandidateMeetingId('').catch((error) => {
        console.error(error);
      });
    }

    if(this.checkForHostsInterval){
      clearInterval(this.checkForHostsInterval);
      this.checkForHostsInterval = undefined;
    }
    if(this.checkForSecondViewParticipantInterval){
      clearInterval(this.checkForSecondViewParticipantInterval);
      this.checkForSecondViewParticipantInterval = undefined;
    }
    this.stopPublishing(false);
    this.notifyOfProctorPresence(false, '');
    if(this.meetingHandlerService.meetingid && this.meetingHandlerService.jwt && this.meetingHandlerService.clientInstanceId){
      this.meetingService.selfDisconnectAndDeassign(this.meetingHandlerService.domain, this.meetingHandlerService.jwt, this.meetingHandlerService.clientInstanceId, false);
      //this.meetingService.deassignMeetingServer(this.meetingHandlerService.meetingid, this.meetingHandlerService.jwt, this.meetingHandlerService.clientInstanceId);
    }
    
    if (this.started && !this.meetingHandlerService.leaving) { //this.started is set to false when cbt asks proctor to stop
      //await this.meetingHandlerService.leaveMeeting(false);
      let passporturl = this.getPassportUrl();
      //this.findAndConnectToMeetingUntilSuccessful(this.meetingHandlerService.defaultRoom, { examid: this.proctorService.examid, passporturl: passporturl });
      const _connect = () => {
        this.findAndConnectToMeetingUntilSuccessful(this.meetingHandlerService.defaultRoom, { examid: this.examid, passporturl: passporturl, secondView: this.isSecondViewProctor }).then(async (successful) => {
          if(successful === true){
            console.log('connected successfully');
            //debugger;
            //this.started = true;
            await this.publishVideo();
          }
          else{
            //means we've asked it to stop connecting
          }
        }).catch((error) => {
          console.error(error);
          _connect();//we should never get here because findAndConnectToMeetingUntilSuccessful catches everthing
        });
      }

      // let secondViewPromise: Promise<any>;
      // if(this.secondViewRequired){
      //   secondViewPromise = this.initiateAndConfirmSecondView();
      // }
      // else{
      //   //so that we have a promise that resolves immediately
      //   secondViewPromise = Promise.resolve(null);
      // }

      // secondViewPromise.then(() => {
      //   _connect();
      // }).catch((error) => {
      //   console.error(error);
      //   setTimeout(() => { this.handleDisconnectFromLiveProctor() });
      // })

      _connect();
    }
  }

  notifyOfProctorPresence(proctorPresent: boolean, proctorSocketId: string) {
    if(proctorPresent){
      this.proctorSocketId = proctorSocketId;
      //entered room used to be used for when the proctor has dragged the candidate into a proctor room
      this.examIframeComponent?.examIframe.nativeElement.contentWindow.postMessage({ event: 'enteredroom' }, '*');
    }
    else{
      this.proctorSocketId = '';
      //left room used to be used for when the proctor has left the room or when the candidate has disconnected from the proctor's room
      this.examIframeComponent?.examIframe.nativeElement.contentWindow.postMessage({ event: 'leftroom' }, '*');
    }
  }

  async getSecondViewDeviceInfo(primaryViewWebcamDeviceLabel: string): Promise<{ deviceId: string; deviceLabel: string; }>{
    //safari resets the device ids whenever the browser goes to a new URL
    //regardless of whether it's an SPA
    //so we have to use the device labels instead of the device id for the comparisons below
    
    //const mainVideoTrackSettings = (await this.getVideoStream(this.allowExternalWebcam))?.getVideoTracks()[0]?.getSettings();
          
    if(primaryViewWebcamDeviceLabel){
      let secondViewDeviceId: string;
      let secondViewDeviceLabel: string;
      const devices = await navigator.mediaDevices.enumerateDevices();
      for(let i = 0; i < devices.length; i++){
        if(devices[i].kind == 'videoinput' && devices[i].label != primaryViewWebcamDeviceLabel && !this.isLikelyVirtualCamera(devices[i].label)){
          secondViewDeviceId = devices[i].deviceId;
          secondViewDeviceLabel = devices[i].label;
          return {deviceId: secondViewDeviceId, deviceLabel: secondViewDeviceLabel};
        }
      }
    }

    return null;
        
  }

  async getServerTimeTicks(): Promise<number>{
    return (await this.util.tryGet(`${environment.proctorServiceRootUrl}recordings3/getservertimeticks`,
      { headers: this.req_headers })).time;
  }

  async getLastVideoRecordingLogtimes(): Promise<{privaryVideoLogTime: number, secondViewVideoLogTime: number}>{
    return (await this.util.tryGet(`${environment.proctorServiceRootUrl}recordings3/getlastvideorecordinglogtimes?examId=${this.examid}&scheduleId=${this.scheduleid}`,
      { headers: this.req_headers }));
  }

  async secondViewRecordingFound(startedWaitingAtTick: number): Promise<boolean>{
    //the recording is found if we have a log time that is after the time we started waiting
    //for this to work, we must be comparing with server time
    const times = await this.getLastVideoRecordingLogtimes();
    return times.secondViewVideoLogTime > startedWaitingAtTick
  }

  // async askAndInitiateExternalSecondView(): Promise<boolean>{
    

    

  //   return ret;
  // }

  async waitForSecondViewRecording(cancellationToken: CancellationToken){
    //we keep checking to see if there is a recording log time that is after the time we started checking
    //we have to use server time because the client's time may be very different from the client's time
    //also the recording log time is set by the server when a recording is logged
    //so if we find a log time that is after the time we started the checks, we know that recording is going on
    const startedWaitingAtTicks = await this.getServerTimeTicks();
    while(!cancellationToken || !cancellationToken.cancel){
      if(await this.secondViewRecordingFound(startedWaitingAtTicks)){
        break;
      }
      else{
        await this.sleep(5000);
      }
    }
  }

  private async initiateAndConfirmSecondView(data: any){
    
    //show popup asking the candidate if they want to use an external webcam or external device for second view
    //the question only gets asked if they have an external webcam already plugged in
    // if they choose to use an external device, an access code will be displayed. this access code stays the same
    const initiateSecondViewModalRef = this.modalService.open(
      InitiateSecondViewModalComponent, {
        backdrop: 'static',
        keyboard: false,
        size: 'lg',
        centered: true,
      }
    );

    const secondViewPreferencePromise = new Promise<boolean>((resolve, reject) => {
      initiateSecondViewModalRef.componentInstance.secondViewPreferencePromiseResolveFunction = resolve;
      initiateSecondViewModalRef.componentInstance.secondViewPreferencePromiseRejectFunction = reject;
      //initiateSecondViewModalRef.componentInstance.primaryViewWebcamDeviceId = primaryViewWebcamDeviceId;
      //initiateSecondViewModalRef.componentInstance.primaryViewWebcamDeviceLabel = primaryViewWebcamDeviceLabel;
      initiateSecondViewModalRef.componentInstance.primaryViewInitiationData = data;
    });

    try{
      let externalDeviceChosen;
      externalDeviceChosen = await secondViewPreferencePromise;
    }
    finally{
      initiateSecondViewModalRef.close();
    }
  }

  async generateSecondViewAccessCode(){
    return (await this.util.tryPost(`${environment.proctorServiceRootUrl}requestss3/generatesecondviewaccesscode`,
      { examId: this.examid, scheduleId: this.scheduleid },
      { headers: this.req_headers })).secondViewAccessCode;
  }

  public async setSecondViewAnglesAccepted(accepted: boolean){
    return (await this.util.tryPost(`${environment.proctorServiceRootUrl}requestss3/setsecondviewanglesaccepted`,
      { examId: this.examid, scheduleId: this.scheduleid, accepted: accepted },
      { headers: this.req_headers }));
  }

  public async getSecondViewAnglesAcceptedFromInteractiveSecondView(accessCode: string): Promise<boolean>{
    return (await this.util.tryGet(`${environment.proctorServiceRootUrl}requestss3/getsecondviewanglesaccepted?examNo=${encodeURIComponent(this.loggedInUsername)}&accessCode=${encodeURIComponent(accessCode)}`,
      { headers: this.req_headers })).accepted;
  }

  public async getSecondViewAnglesAcceptedFromMainScreen(): Promise<boolean>{
    return (await this.util.tryGet(`${environment.proctorServiceRootUrl}requestss3/getsecondviewanglesaccepted?examId=${encodeURIComponent(this.examid)}&scheduleId=${encodeURIComponent(this.scheduleid)}`,
      { headers: this.req_headers })).accepted;
  }

  public async uploadSecondViewSnapshot(accessCode: string, imageDataUrl: string){
    return (await this.util.tryPost(`${environment.proctorServiceRootUrl}requestss3/uploadsecondviewrecordingsnapshot`,
      { examNo: this.loggedInUsername, accessCode: accessCode, imageDataUrl: imageDataUrl },
      { headers: this.req_headers }));
  }

  public async getSecondViewSnapshotObjectUrl(newerThan_Ticks: number){
    const blob = await this.http.get(`${environment.proctorServiceRootUrl}requestss3/getlatestsecondviewrecordingsnapshot?examId=${encodeURIComponent(this.examid)}&scheduleId=${encodeURIComponent(this.scheduleid)}&newerThan_Ticks=${newerThan_Ticks}&random=${Math.random()}`,
    {headers: this.req_headers, responseType: 'blob'}).toPromise();

    const objectURL = URL.createObjectURL(blob);

    return objectURL;
  }

  public async checkExamEndedFromInteractiveSecondView(accessCode){
    return (await this.util.tryGet(`${environment.proctorServiceRootUrl}requestss3/checksecondviewexamended?examNo=${encodeURIComponent(this.loggedInUsername)}&accessCode=${encodeURIComponent(accessCode)}`,
      { headers: this.req_headers })).ended;
  }

  public async registerExternalCandidate(){
    return (await this.util.tryPost(`${environment.proctorServiceRootUrl}requests/registerexternalcandidate`,
      { examId: this.examid, name: this.name, examNo: this.loggedInUsername },
      { headers: this.req_headers })).scheduleId;
  }

  public createSecondViewRTCPeerConnection(){
    try{
      this.secondViewRTCPeerConnection?.close();
    }
    catch(error){
      console.error('Error closing second view webrtc peer connection: ', error);
    }

    const peerConnection = new RTCPeerConnection({
      iceServers: [{ urls: 'stun:stun.l.google.com:19302' }]
    });

    if(this.isSecondViewProctor){
      peerConnection.addTransceiver('video', { direction: 'sendonly' });
      peerConnection.addTransceiver('audio', { direction: 'sendonly' });
    }
    else{
      peerConnection.addTransceiver('video', { direction: 'recvonly' });
      peerConnection.addTransceiver('audio', { direction: 'recvonly' });
    }

    //const candidates: any[] = [];

    peerConnection.onicecandidate = async event => {
      // if (event.candidate) {
      //   //debugger;
      //   //candidates.push(event.candidate);
        
      // }
      // else{
        
      // }
      await this.setInteractiveSecondViewWebRTCIceCandidates(event.candidate);
      console.log('sent ice candidates: ', event.candidate);
    };

    this.secondViewRTCPeerConnection = peerConnection;
    return peerConnection;
  }

  public async setInteractiveSecondViewWebRTCIceCandidates(candidate: any) {
    while(true){
      try{
        return (await this.util.tryPost(`${environment.proctorServiceRootUrl}requestss3/setinteractivesecondviewwebrtcicecandidates`,
          { examId: this.examid, scheduleId: this.scheduleid, secondView: this.isSecondViewProctor, candidate: candidate },
          { headers: this.req_headers }));
      }
      catch(err){
        console.error(err);
        await this.util.sleep(500);
      }
    }
  }

  public async setInteractiveSecondViewWebRTCOffer(offer: any) {
    while(true){
      try{
        return (await this.util.tryPost(`${environment.proctorServiceRootUrl}requestss3/setinteractivesecondviewwebrtcoffer`,
          { examId: this.examid, scheduleId: this.scheduleid, secondView: this.isSecondViewProctor, offer: offer },
          { headers: this.req_headers }));
      }
      catch(err){
        console.error(err);
        await this.util.sleep(500);
      }
    }
  }

  public async getInteractiveSecondViewWebRTCDescription(secondView: boolean){
    return (await this.util.tryGet(`${environment.proctorServiceRootUrl}requestss3/getinteractivesecondviewwebrtcdescription?examId=${encodeURIComponent(this.examid)}&scheduleId=${encodeURIComponent(this.scheduleid)}&secondView=${encodeURIComponent(secondView)}`,
      { headers: this.req_headers }))
  }

  public async getInteractiveSecondViewWebRTCRemoteCandidates(){
    return (await this.util.tryGet(`${environment.proctorServiceRootUrl}requestss3/getinteractivesecondviewwebrtcicecandidates?examId=${encodeURIComponent(this.examid)}&scheduleId=${encodeURIComponent(this.scheduleid)}&secondView=${encodeURIComponent(!this.isSecondViewProctor)}`,
      { headers: this.req_headers }))
  }

  public async clearInteractiveSecondViewWebRTCInfo(){
    return (await this.util.tryPost(`${environment.proctorServiceRootUrl}requestss3/clearinteractivesecondviewwebrtcinfo`,
      { examId: this.examid, scheduleId: this.scheduleid },
      { headers: this.req_headers }));
  }
  // private signalSecondViewToConnectToLiveProctor(secondViewIframeComponent: SecondViewIframeComponent, meetingid: string){
  //   this.sendMessageToSecondViewIframe(secondViewIframeComponent.secondViewIframe.nativeElement.contentWindow, { operation: 'connecttoproctoringmeeting', meetingid });
  // }
}
